// Studyo Today Backend
// Package studyo.today.schedules.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schedules/v1/resources/day_annotation.proto (package studyo.today.schedules.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schedules/v1/resources/day_annotation.proto.
 */
export const file_studyo_today_schedules_v1_resources_day_annotation = /*@__PURE__*/
  fileDesc("CjhzdHVkeW8vdG9kYXkvc2NoZWR1bGVzL3YxL3Jlc291cmNlcy9kYXlfYW5ub3RhdGlvbi5wcm90bxIjc3R1ZHlvLnRvZGF5LnNjaGVkdWxlcy52MS5yZXNvdXJjZXMiXAoNRGF5QW5ub3RhdGlvbhINCgV0aXRsZRgBIAEoCRIOCgZzeW1ib2wYAiABKAkSDQoFY29sb3IYAyABKAkSHQoVaXNfZW5kX29mX3Rlcm1fbWFya2VyGAQgASgIQiuqAihTdHVkeW8uVG9kYXkuU2NoZWR1bGVzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the message studyo.today.schedules.v1.resources.DayAnnotation.
 * Use `create(DayAnnotationSchema)` to create a new message.
 */
export const DayAnnotationSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schedules_v1_resources_day_annotation, 0);

